export default "__VITE_ASSET__1732511b__"